<template>
  <div>
    <p>页面不存在</p>
  </div>
</template>

<script>

export default {
  data () {
    return {
      
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/404.vue